// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
import VeeValidate from 'vee-validate'
import VueCalendar from 'vue-full-calendar'
import wysiwyg from 'vue-wysiwyg'
import $ from 'jquery'
import routes from './routes.js'

require('sweetalert2/dist/sweetalert2.min.css')
require('vue-wysiwyg/dist/vueWysiwyg.css')

const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true
}

// We want to apply VueResource and VueRouter
// to our Vue instance
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(VeeValidate, config)
Vue.use(VueCalendar)
Vue.use(wysiwyg)

// Global components
import AppHeader from './components/Header.vue'
import Sidebar from './components/Sidebar.vue'
import Aside from './components/Aside.vue'
import Footer from './components/Footer.vue'

const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  history: true
})

// protect routes. Allow user which are logged in
router.beforeEach((to, from, next) => {
  var cookies = VueCookies

  // check if the token is almost expire then refresh the token
  if (cookies.isKey('op_session')) {
    let dateNow = parseInt((new Date().getTime() / 1000))
    if (dateNow >= cookies.get('op_session_last') || !cookies.isKey('op_session_last')) {
      Vue.http.post(process.env.API_ENDPOINT + '/user/refresh?token=' + cookies.get('op_session')).then((response) => {
        cookies.remove('op_session')
        cookies.remove('op_session_content')
        cookies.set('op_session', response.body.token, 2629746)
        cookies.set('op_session_content', JSON.stringify(response.body), 2629746)

        let date = new Date()
        let nextSessionCheck = new Date(date.setMinutes(date.getMinutes() + 41760)).getTime() / 1000
        cookies.set('op_session_last', parseInt(nextSessionCheck), 2629746)
      }, (response) => {
        console.log(response)
      })
    }
  }
  if (to.path !== '/login' && to.path !== '/register' && to.name !== '/signup' && to.path !== '/forgot-password' && to.name !== '/reset-password' && to.name !== '/api/password/reset') {
    // if token is not set redirect to /login
    if (cookies.get('op_session') === null) {
      next({ path: '/login' })
    } else {
      next()
    }
  } else {
    if (cookies.get('op_session') !== null) {
      next({ path: '/dashboard' })
    } else {
      next()
    }
  }
  if (!to.query.page) {
    $('html, body').animate({ scrollTop: 0 }, 'slow')
  }
})

new Vue({
  components: {
    'app-header': AppHeader,
    'app-sidebar': Sidebar,
    'app-aside': Aside,
    'app-footer': Footer
  },
  router,
  methods: {
    isAdminPage: function (path, name) {
      let publicComponents = ['/login', '/register', '/signup', '/forgot-password', '/reset-password', '/api/password/reset']
      return publicComponents.indexOf(path) >= 0 || publicComponents.indexOf(name) >= 0
    }
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js